const domainStrings = {
  buyNow: 'Buy Now',
  learnMore: 'Learn More',
  setupSectionTitle: 'Step 1: Get your domain online',
  setupSectionDescription:
    'Ready to showcase your domain to the world? Get started with these products.',
  setupSectionAria: 'setup-domain-section',
  protectionSectionTitle: 'Step 2: Protect your domain',
  protectionSectionDescription:
    'The best domain protection money can buy. Safeguard your valuable domains.',
  protectionSectionAria: 'domain-protection-section',
  seoSectionTitle: 'Step 3: Boost website traffic',
  seoSectionDescription:
    'Improve your SEO in minutes with MarketGoo. No tech skills needed.',
  seoSectionAria: 'domain-seo-section',
  domainRegistration: 'Register a Domain',
  emailHosting: 'Add a custom email',
  emailHostingSubtext:
    'A custom email address that matches your domain makes your business look more credible.',
  webHosting: 'Add a WordPress website or hosting',
  webHostingSubtext: 'Find a Web Hosting plan that works for you',
  sslCertificate: 'SSL Certificate',
  sslCertificateSubtext:
    'Protect the exchange of personal and secure information on your site',
  privacyProtection: 'Privacy Protection',
  privacyProtectionSubtext:
    'Secure your domains and hide your personal information from the WHOIS directory',
  expiryProtection: 'Expiry Protection',
  expiryProtectionSubtext:
    "We'll keep your domain for you incase of a credit card expiry or failed payment.",
  ownershipProtection: 'Ownership Protection',
  ownershipProtectionSubtext:
    'Prevent your site information from being changed, stolen or accidentally moved to someone else’s account by anyone with account access.',
  seoTools: 'SEO Tools - Powered by Marketgoo',
  seoToolsSubtext: 'Easy do-it-yourself search engine optimization.',
  weeblySite: 'Build a website - Powered by Weebly',
  weeblySiteSubtext: `Build yourself a modern and professional website using this easy-to-use drag and drop tool`,
  setupTitleIncomplete: "Let's setup your domain!",
  setupTitleComplete: 'Well done, your domain is setup!',
  setupDismiss: 'Dismiss',
  setupGetStarted: 'Get Started',
  setupIncompleteDescriptionL1:
    'Make the most of your domain with our products and services.',
  setupIncompleteDescriptionL2(active, max) {
    return `Your domain has ${active} of ${max} potential products activated`
  },
  setupCompleteDescription(max) {
    return `Your domain has ${max} of ${max} products activated`
  },
  domainRecovery(days) {
    return `You have ${days} days left to recover this domain.`
  },
  domainRedemption(days) {
    return `You have an additional ${days} days left to redeem this domain.`
  },
  postOrderTitle: 'Thank you for your order',
  postOrderDescription(orderId) {
    return `Order ${orderId} was successfully placed and is now processing.`
  },
  postOrderDownloadPDF: 'View Receipt',
  rgpButton: 'Recovery Manager',
  noDomainSectionTitle: 'Get your idea online',
  noDomainSectionAria: 'no-domain-section',
  noDomainSectionDescription:
    'Ready to share your idea with the world? Get started with one of these products.',
  noDomainRegistrationSectionDescription:
    'Got an idea? Get the domain (before someone else does).',
  hostingMigration: 'Free Hosting Migration',
  hostingMigrationsSubtext:
    'Move your websites to Rebel for free - our migration experts will do it for you',
}

export { domainStrings }
